<template>
    <div class="Error">
      <div class="ErrorContainer">
        <AppHeader mode="simple" />
        <div class="ErrorInner">
          <div class="ErrorContents">
            <NotFound v-if="error.statusCode === 404" />
            <OtherError v-else />
          </div>
        </div>
        <AppFooter/>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineNuxtComponent, useSeoMeta, useRuntimeConfig } from '#imports'
  import NotFound from '@/containers/Exceptions/NotFound'
  import OtherError from '@/containers/Exceptions/OtherError'
  import AppHeader from '@/containers/Header'
  import AppFooter from '@/containers/Footer'
  
  export default defineNuxtComponent({
    components: {
      NotFound,
      OtherError,
      AppHeader,
      AppFooter
    },
    props: {
      error: {
        type: Object,
        required: true
      },
    },
    setup(props) {
      const { public: { APP_ENV } } = useRuntimeConfig()

      const title = props.error?.statusCode === 404 ? 'お探しのページが見つかりませんでした - カーナベル' : 'アクセスしたページを表示できませんでした - カーナベル'
      useSeoMeta({
        title,
        ogTitle: title,
        robots: APP_ENV==='production' ? 'noindex,follow' :'noindex,nofollow',
      })
      useHead({
        htmlAttrs: {
          lang: 'ja'
        }
      })
    }
  })
  </script>
  
  <style scoped>
  .Error {
      width: 100%;
  }
  
  .ErrorContainer {
    width: 100%;
    padding-top: 56px;
    margin: 0 auto;
  }
  
  @media screen and (min-width: 430px) {
    .ErrorContainer {
      width: 430px;
    }
  }
  
  .ErrorInner {
      width: 100%;
  }
  
  .ErrorContents {
      padding: 20px 16px 48px;
  }
  </style>